export default "__VITE_ASSET__VEuhKQps__"